import React, { Component } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
// import Alert from "react-s-alert";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../../store/validation/is-Empty";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

export class LocatedInsideOnboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vendor_id: "",
      actionButton: false,
      selectedTab: 2,
      all_located_inside_icons: [],
      selected_located_inside: [],
      hasSetMapProps: false,
      loader: false,
    };
  }

  componentDidMount() {
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    let adminVendorId = this.props?.editDataAction
      ? this.props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      this.props.superadmin_create_and_update_restaurant(formData);
      this.setState({
        vendor_id: formData.vendor_id,
      });
    }
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let onboarding = nextProps?.editDataAction
      ? nextProps?.editData
      : nextProps?.onboardingData;
    if (
      !isEmpty(onboarding?._id) &&
      !isEmpty(nextProps.located_inside) &&
      !nextState.hasSetMapProps
    ) {
      let selected_located_inside = onboarding?.selected_located_inside;
      if (!isEmpty(selected_located_inside[0])) {
        if (
          isEmpty(selected_located_inside[0]._id) &&
          selected_located_inside.length > 0
        ) {
          selected_located_inside = nextProps.located_inside.filter(
            (location) =>
              selected_located_inside.includes(location._id) &&
              location.status !== "NOTAPPROVED"
          );
        }
      }
      return {
        all_located_inside_icons: nextProps.located_inside,
        selected_located_inside: !isEmpty(selected_located_inside)
          ? selected_located_inside
          : [],
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }
  /*********************************************
   * @DESC - onLocated Inside Array Selector
   *********************************************/
  onLocatedInsideArraySelector = (icon) => (e) => {
    e.preventDefault();
    let restaurantTypeArray = this.state.selected_located_inside;
    if (restaurantTypeArray.length === 0) {
      restaurantTypeArray.push(icon);
    } else {
      let isAlreadyPresent = restaurantTypeArray.some(
        (icons) => icons._id === icon._id
      );
      if (isAlreadyPresent) {
        let indexOf = restaurantTypeArray.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          restaurantTypeArray.splice(indexOf, 1);
        }
      } else {
        restaurantTypeArray.push(icon);
      }
    }
    this.setState({
      selected_located_inside: restaurantTypeArray,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: this.props?.editDataAction
        ? "/admin_edit_pointofsale"
        : "/addvendorpointofsale",
      state: { data: "located_inside" },
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    let onboarding = this.props?.editDataAction
      ? this.props?.editData
      : this.props?.onboardingData;
    if (onboarding && onboarding?.selected_located_inside.length > 0) {
      const formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding?._id,
        selected_located_inside: this.state.selected_located_inside,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: this.props?.editDataAction
          ? "/admin_edit_pointofsale"
          : "/addvendorpointofsale",
        state: { data: "located_inside" },
      });
    } else {
      const formData = {
        vendor_id: this.state.vendor_id,
        id: onboarding?._id,
        selected_located_inside: this.state.selected_located_inside,
        page_completed_till: 14,
      };
      this.props.superadmin_create_and_update_restaurant(formData);
      this.props.history.push({
        pathname: this.props?.editDataAction
          ? "/admin_edit_pointofsale"
          : "/addvendorpointofsale",
        state: { data: "located_inside" },
      });
    }
  };

  renderLocatedInsideFields = (actionButton, allIcons, selectedIcons) => {
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main margin-bottom-chains-onboarding">
          <div>
            <div className="cuisine-main ">
              <div className="col-12 located-inside-heading-text">
                <h3>Facility Is located inside Premises:</h3>
                <p>
                  (If you are located within any building or facility select
                  below)
                </p>
              </div>
              <div
                className={
                  allIcons.length > 8 ? "cuisine-main-padding-border" : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {allIcons.map((icon, index) => {
                    return (
                      <ReusableOnboardingMapButton
                        key={index}
                        classsection={
                          selectedIcons.some((icons) => icons._id === icon._id)
                            ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                            : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        }
                        src={icon.icon}
                        title={icon.title}
                        onClick={this.onLocatedInsideArraySelector(icon)}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d0e"} />
              </div>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link={
                this.props?.editDataAction
                  ? "/admin_edit_serviceoffered"
                  : "/addvendorserviceoffered"
              }
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              disabled={isEmpty(this.state.selected_located_inside)}
              buttonClass={`onboarding_button_link_reusable ${
                isEmpty(this.state.selected_located_inside)
                  ? "onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable_red ml-3"
              }`}
              buttonText="Next"
              onClick={actionButton === false ? this.onWithOutApiCall : null}
              buttonType={actionButton === false ? "button" : "submit"}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <div className="col-6 pl-5 pr-5">
                <div className="super_admin_add_vendor mb-4">
                  <h5 className="main_header_text">
                    {this.props?.editDataAction ? "Edit" : "Add"} Vendor
                  </h5>
                  <h4 className="font_20_m">Step : 14</h4>
                  <h4 className="font_20_m c_red mt-2 mb-1">Located Inside</h4>
                  <hr className="hr_line" />
                </div>
                <TopTextReusableComponent
                  headingText="Located Inside"
                  headingParagraph="Enter the information about your Business Establishment"
                />
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderLocatedInsideFields(
                    this.state.actionButton,
                    this.state.all_located_inside_icons,
                    this.state.selected_located_inside
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
  located_inside: state.category.located_inside,
});

export default connect(mapStateToProps, {
  superadmin_create_and_update_restaurant,
})(withRouter(LocatedInsideOnboarding));
